//      strict
export const faIcon = {
  display: "inline-block",
  fontSize: "inherit",
  height: "1em",
  overflow: "visible",
  verticalAlign: "-0.125em",
};
